import TablePage from './table';

export default {
  name: 'menuManage',
  extends: TablePage,
  data() {
    return {};
  },
  methods: {},
  created() {},
};
